import { Drawer } from 'antd';
import React, { Dispatch, SetStateAction } from 'react';
import { CloseIcon } from '../../../../components/icons';
import { Permission, Role } from '../../../../interfaces/User';
import { PermissionsView } from './PermissionsView';
import { useMediaQuery } from '@mui/material';
import { theme } from '../../../../components/theme/theme';

const ViewPermissionModal = ({
    role,
    viewPermission,
    setViewPermission,
    isCustom = false,
    setSelectedRole
}: {
    role?: Role;
    viewPermission: boolean;
    setViewPermission: Dispatch<SetStateAction<boolean>>;
    isCustom?: boolean;
    setSelectedRole: Dispatch<SetStateAction<Role | undefined>>;
}) => {
    const closeModal = () => {
        setViewPermission(false);
        setSelectedRole(undefined);
    };
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Drawer
            placement={isMobile ? 'bottom' : 'right'}
            closable={false}
            onClose={() => closeModal()}
            open={viewPermission}
            width={430}
            height={'75vh'}
            className='!bg-white !rounded-t-xl pt-6 lg:pt-0 lg:!rounded-t-none'
        >
            <div className='px-4 lg:w-[400px] mx-auto py-4 lg:max-w-[400px] w-full relative'>
                <div
                    className='absolute right-2 lg:top-10 top-0 cursor-pointer'
                    onClick={closeModal}
                >
                    <CloseIcon />
                </div>
                <h2 className='lg:pt-8 mb-2 text-[18px] font-semibold text-ebony'>
                    {role?.name || ''}
                </h2>
                <h5 className='!text-sm !text-midnightHaze font-light !mb-[24px]'>
                    {role?.description || ''}
                </h5>
                <h5 className='!text-sm !text-midnightHaze font-light !mb-2'>
                    This Role has the following permissions:
                </h5>

                <PermissionsView
                    actionPermissions={role?.permissions ?? ({} as Permission)}
                    isCustom={isCustom}
                />
            </div>
        </Drawer>
    );
};

export default ViewPermissionModal;
